import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  Typography,
  makeStyles,
  createStyles,
  FormControl,
  Grid,
} from '@material-ui/core'
import { getReviews } from '../../redux/actions/reviews'
import Loader from '../Loader/Loader'

type Tprops = {
  doc: any
  orderId: string
  answersSaved: any
  reviews: any
  sku: string
  t: any
  saveAnswers: any
  getReviews: (id: string) => any
}

const mapStateToProps = (state) => ({
  reviews: state.reviews,
})

const mapDispatchToProps = {
  getReviews: getReviews,
}

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      '& .MuiInput-multiline': {
        padding: 0,
        '&:before, &:after': {
          display: 'none',
        },
      },
    },
    formControl: {
      width: '100%',
    },
    sizeSelector: {
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(0.5, 2, 0.5, 1),
      margin: theme.spacing(0.5),
      backgroundColor: theme.extraColors.greyLight,
      minWidth: 200,
      color: theme.palette.common.black,
      height: 40,
      fontWeight: 'bold',
      border: 'none',
    },
    smileyContainer: {
      display: 'inline-flex',
      justifyContent: 'space-evenly',
      width: '100%',
      height: 48,
      alignItems: 'center',
    },
    activeSmiley: {
      cursor: 'pointer',
      color: theme.palette.secondary.main,
    },
    smiley: {
      cursor: 'pointer',
      color: theme.extraColors.grey,
    },
    questionTitle: {
      padding: theme.spacing(0.5),
    },
    loaderBox: {
      width: '100%',
      display: 'inline-flex',
      justifyContent: 'center',
      padding: theme.spacing(2),
    },
  })
)

const ProductSatisfactionForm = ({
  reviews,
  getReviews,
  sku,
  answersSaved,
  saveAnswers,
  t,
  orderId,
}: Tprops) => {
  const classes = useStyles()
  const [answers, setAnswers] = useState([])
  const [productReview, setProductReview] = useState({
    sku: null,
    questions: null,
  })
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    const asyncFunc = async () => {
      setIsLoading(true)
      if (orderId && !reviews?.items?.find((item) => item.sku === sku)) {
        const requestResponse = await getReviews(orderId)
        if (requestResponse?.reviews?.length > 0) {
          setProductReview(requestResponse.reviews[0])
        } else {
          setProductReview({ sku: null, questions: null })
        }
      } else {
        setProductReview(reviews?.items?.find((item) => item.sku === sku))
      }
      setIsLoading(false)
    }
    asyncFunc()
  }, [orderId])

  const handleStateCommand = (event, idQuestion) => {
    const currentAnswers = [...answers]
    if (
      currentAnswers.find((answer) => answer.reviewQuestionId === idQuestion)
    ) {
      currentAnswers.splice(
        currentAnswers.findIndex(
          (answer) => answer.reviewQuestionId === idQuestion
        ),
        1
      )
    }
    currentAnswers.push({
      reviewQuestionId: idQuestion,
      questionChoiceId: parseInt(event.target.value),
    })
    setAnswers(currentAnswers)
    saveAnswers(currentAnswers, sku, orderId)
  }

  const handleStateRate = (event, idQuestion, defaultQuestionId) => {
    const currentAnswers = [...answers]
    if (
      currentAnswers.find((answer) => answer.reviewQuestionId === idQuestion)
    ) {
      currentAnswers.splice(
        currentAnswers.findIndex(
          (answer) => answer.reviewQuestionId === idQuestion
        ),
        1
      )
    }
    currentAnswers.push({
      reviewQuestionId: idQuestion,
      rate: parseInt(event.target.value),
      questionChoiceId: defaultQuestionId,
    })
    setAnswers(currentAnswers)
    saveAnswers(currentAnswers, sku, orderId)
  }

  return (
    <>
      {isLoading ? (
        <div className={classes.loaderBox}>
          <Loader />
        </div>
      ) : (
        <div className={classes.root}>
          {productReview?.questions ? (
            <Grid container spacing={2}>
              {productReview?.questions.map((question, index) => {
                const arrayRate = []
                if (question.rate) {
                  for (let i = question.min; i <= question.max; i++) {
                    arrayRate.push(i)
                  }
                }
                return (
                  <Grid item xs={12} sm={6} key={index}>
                    <Typography
                      variant={'body2'}
                      className={classes.questionTitle}
                    >
                      {question.title}
                    </Typography>
                    {question.rate ? (
                      <>
                        <FormControl
                          variant="outlined"
                          className={classes.formControl}
                        >
                          <select
                            value={
                              answersSaved?.answers?.find(
                                (answer) =>
                                  answer.reviewQuestionId === question.id
                              )?.rate
                                ? answersSaved?.answers?.find(
                                    (answer) =>
                                      answer.reviewQuestionId === question.id
                                  )?.rate
                                : ''
                            }
                            onChange={(event) =>
                              handleStateRate(
                                event,
                                question.id,
                                question.questionChoices[0].id
                              )
                            }
                            placeholder={t('account:review_placeholder')}
                            className={classes.sizeSelector}
                          >
                            <option aria-label="None" value="">
                              {t('texts:account:review_placeholder')}
                            </option>
                            {arrayRate.map((option, index) => {
                              return (
                                <option key={index} value={option}>
                                  {option}
                                </option>
                              )
                            })}
                          </select>
                        </FormControl>
                      </>
                    ) : (
                      <>
                        <FormControl
                          variant="outlined"
                          className={classes.formControl}
                        >
                          <select
                            value={
                              answersSaved?.answers?.find(
                                (answer) =>
                                  answer.reviewQuestionId === question.id
                              )?.questionChoiceId
                                ? answersSaved?.answers?.find(
                                    (answer) =>
                                      answer.reviewQuestionId === question.id
                                  )?.questionChoiceId
                                : ''
                            }
                            onChange={(event) =>
                              handleStateCommand(event, question.id)
                            }
                            className={classes.sizeSelector}
                          >
                            <option aria-label="None" value="">
                              {t('texts:account:review_placeholder')}
                            </option>
                            {question.questionChoices.map((option, index) => {
                              return (
                                <option key={index} value={option.id}>
                                  {option.choice}
                                </option>
                              )
                            })}
                          </select>
                        </FormControl>
                      </>
                    )}
                  </Grid>
                )
              })}
            </Grid>
          ) : (
            <></>
          )}
        </div>
      )}
    </>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductSatisfactionForm)
